export default "https://assets.egbcdn.net/assets/packs/_/sounds/poker/your-turn-4bb987c8cfd9a979fe54be56f358a910.mp3";